const GroupByRole = ({ items }) => {
  const validItems = items.filter((item) => item && item.role && item.name);

  const grouped = validItems.reduce((acc, item) => {
    if (!acc[item.role]) acc[item.role] = [];
    acc[item.role].push(`${item.name}${item.date ? ` (${item.date})` : ""}`);
    return acc;
  }, {});

  return (
    <div>
      {Object.entries(grouped).map(([role, names], i) => (
        <p key={i} className="text-black">
          <span className="font-lato-light-important text-base">{role}:</span>
          <span className="inline-block w-2"></span>
          <span className="font-lato-light-important text-base">
            {names.join(" / ")}
          </span>
        </p>
      ))}
    </div>
  );
};

export default GroupByRole;
